import * as R from 'ramda';

export default function CRICategoryController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.eCat;
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpand = _handleExpand;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('updateCounts', (event, opt) => {
      if (opt.criCategoryId === vm.criCategory.criCategoryId) {
        _updateCategoryCount(opt.add, opt.remove);
      }
    });
  }

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _updateCategoryCount(addTypeId, removeTypeId) {
    if (vm.isEdit) {
      if (addTypeId == 1) {
        vm.criCategory.notStartedCount = vm.criCategory.notStartedCount + 1;
      } else if (addTypeId == 2) {
        vm.criCategory.inProgressCount = vm.criCategory.inProgressCount + 1;
      } else if (addTypeId == 3) {
        vm.criCategory.completedCount = vm.criCategory.completedCount + 1;
      } else if (addTypeId == 4) {
        vm.criCategory.notIncludedCount = vm.criCategory.notIncludedCount + 1;
      }

      if (removeTypeId == 1) {
        vm.criCategory.notStartedCount = vm.criCategory.notStartedCount - 1;
      } else if (removeTypeId == 2) {
        vm.criCategory.inProgressCount = vm.criCategory.inProgressCount - 1;
      } else if (removeTypeId == 3) {
        vm.criCategory.completedCount = vm.criCategory.completedCount - 1;
      } else if (removeTypeId == 4) {
        vm.criCategory.notIncludedCount = vm.criCategory.notIncludedCount - 1;
      }
    }
  }
}

CRICategoryController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds',
];
